import _ from 'lodash';
import Box from '@amzn/awsui-components-react/polaris/box';
import Icon, {IconProps} from '@amzn/awsui-components-react/polaris/icon';
import * as React from 'react';
import {WorkflowExecutionStatus} from '../../backend/model';

function formatWorkflowStatus(status: string) {
    return _.capitalize(status.replace('_', ' '))
}

type WorkflowStatusIndicatorProps = {
    status: WorkflowExecutionStatus;
}

const WorkflowStatusIndicator: React.FC<WorkflowStatusIndicatorProps> = (props) => {
    const iconName = ({
        [WorkflowExecutionStatus.NOT_STARTED]: 'status-pending' as IconProps.Name,
        [WorkflowExecutionStatus.RUNNING]: 'status-in-progress' as IconProps.Name,
        [WorkflowExecutionStatus.SUCCEEDED]: 'status-positive' as IconProps.Name,
        [WorkflowExecutionStatus.FAILED]: 'status-negative' as IconProps.Name,
    })[props.status]

    const iconVariant = ({
        [WorkflowExecutionStatus.NOT_STARTED]: 'subtle' as IconProps.Variant,
        [WorkflowExecutionStatus.RUNNING]: 'subtle' as IconProps.Variant,
        [WorkflowExecutionStatus.SUCCEEDED]: 'success' as IconProps.Variant,
        [WorkflowExecutionStatus.FAILED]: 'error' as IconProps.Variant,
    })[props.status]

    const textColor = ({
        [WorkflowExecutionStatus.NOT_STARTED]: 'var(--color-text-body-default-2BCA55, #16191f)',
        [WorkflowExecutionStatus.RUNNING]: 'var(--color-text-body-default-2BCA55, #16191f)',
        [WorkflowExecutionStatus.SUCCEEDED]: 'var(--color-text-status-success-1HrHCk, #1d8102)',
        [WorkflowExecutionStatus.FAILED]: 'var(--color-text-status-error-2bq2Mw, #d13212)',
    })[props.status]

    return (
        <Box>
            <Icon name={iconName} variant={iconVariant}/>
            <span style={{marginLeft: '5px', color: textColor}}>{formatWorkflowStatus(props.status!)}</span>
        </Box>
    );
}

export default WorkflowStatusIndicator
